import { ArrowLeft, Download, ExternalLink, FileText } from "lucide-react";
import { Link } from "react-router-dom";

const PRICE_LIST_URL = "/descendants-of-the-sun-price-list.pdf";

export function PriceListPage() {
  return (
    <section className="price-list-page" data-testid="price-list-page">
      <div className="section-shell">
        <header className="price-list-heading">
          <div>
            <p className="section-kicker">Descendants of the Sun / 2026</p>
            <h1>Price <em>list.</em></h1>
            <p className="price-list-intro" data-testid="price-list-intro">Original artwork pricing for the Descendants of the Sun series.</p>
          </div>
          <div className="price-list-actions">
            <a className="button button-primary" href={PRICE_LIST_URL} target="_blank" rel="noreferrer" data-testid="price-list-open-link">
              Open original PDF <ExternalLink size={16} strokeWidth={1.4} />
            </a>
            <a className="button button-text" href={PRICE_LIST_URL} download data-testid="price-list-download-link">
              <FileText size={15} strokeWidth={1.4} /> Download price list <Download size={15} strokeWidth={1.4} />
            </a>
          </div>
        </header>
        <div className="price-list-document" data-testid="price-list-document">
          <iframe src={PRICE_LIST_URL} title="Descendants of the Sun price list PDF" data-testid="price-list-pdf" />
        </div>
        <Link className="button button-text price-list-back-link" to="/works" data-testid="price-list-back-link">
          <ArrowLeft size={15} strokeWidth={1.4} /> Back to Works
        </Link>
      </div>
    </section>
  );
}
